import React from 'react';
import PropTypes from "prop-types";
import AbstractTab from "./AbstractTab";
import {connect} from "react-redux";
import {addDetailWindow, setDetailWindow} from "../../actions/details";
import FeatureUtils from "../../utils/FeatureUtils";

class ImageTab extends AbstractTab {

    static propTypes = {
        addDetailWindow: PropTypes.func,
        feature: PropTypes.object,
        setDetailWindow: PropTypes.func,
        tab: PropTypes.object,
        windowId: PropTypes.string,
        windowType: PropTypes.string
    }

    static defaultProps = {
        feature: {},
        tab: {},
        windowId: ''
    }

    constructor(props) {
        super(props);

        const options = {};
        if (this.props.tab.config && this.props.tab.config.options) {
            for (let i = 0; i < this.props.tab.config.options.length; i++) {
                const option = this.props.tab.config.options[i];
                options[option.param] = [];
            }
        }

        this.state = {
            data: {},
            imageSrc: null,
            options: options,
            isLoading: true
        };
    }

    componentDidMount() {
        this.updateImage();
    }

    updateImage() {
        const url = this.getImageUrl();
        const self = this;

        if (this.useAuth()) {
            this.loadImageWithAuth(url, function(datasrc) {
                self.setState({
                    imageSrc: datasrc,
                    isLoading: false
                });
            });
        } else {
            self.setState({
                imageSrc: url,
                isLoading: false
            });
        }
    }

    setOption(param, value) {
        const current = this.state.options;
        if (this.isChecked(param, value)) {
            current[param].push(value);
        } else {
            current[param].splice(current[param].indexOf(value), 1);
        }
        this.setState({options: current});
        this.updateImage();
    }

    isChecked(param, value) {
        return (this.state.options[param].indexOf(value) == -1);
    }

    renderValue(option, value) {
        return (
            <span key={value.value}>
                <label>
                    <input checked={this.isChecked(option.param, value.value)}
                           onChange={ev => this.setOption(option.param, ev.target.value)}
                           type="checkbox" value={value.value}/>
                    {value.label}
                </label>
            </span>
        );
    }

    addOptionsToUrl(url) {
        if (this.props.tab.config && this.props.tab.config.options) {
            for (let i = 0; i < this.props.tab.config.options.length; i++) {
                const option = this.props.tab.config.options[i];
                let append = '&';
                if (url.indexOf('?') == -1) {
                    append = '?';
                }
                url += append + option.param + '=' + encodeURIComponent(this.state.options[option.param].join(','));
            }
        }
        return url;
    }

    renderOption(option) {
        return (
            <div className="feature-details-image-options" key={option.param}>
                {option.values.map(v => this.renderValue(option, v))}
            </div>
        );
    }

    renderOptions() {
        if (this.props.tab.config && this.props.tab.config.options) {
            return (
                <div className="feature-details-image-options">
                    {this.props.tab.config.options.map(o => this.renderOption(o))}
                </div>
            );
        }
        return null;
    }

    getImageUrl() {
        return this.addOptionsToUrl(FeatureUtils.prepareUrl(this.props.feature, this.props.tab.url));
    }

    render() {
        const options = this.renderOptions();
        return (
            <div className="feature-details-image">
                {options}
                <img src={this.state.imageSrc}/>
            </div>
        );
    }
}

const selector = () => (
    {}
);

export default connect(selector,
    {
        setDetailWindow: setDetailWindow,
        addDetailWindow: addDetailWindow,
    }
)(ImageTab);
